import {
  AdminCustomProviderSelect,
  AdminDollarInput2,
  Button,
  Div,
  ErrorToast,
  Modal,
  PropsModal,
  lightTheme,
  renderProviderName,
} from '@vgrubs/components';
import { CUSTOM_PRICE_PROVIDERS } from 'components/src/helpers/customPriceProviders';
import { MenuPriceCustomizationV2Response } from 'components/src/types/menu.types';
import { Provider } from 'components/src/types/shared.types';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Tooltip } from 'react-tooltip';

// TODO: CHECK IF THERE IS DELETE MODAL

export const AddCustomPrice = ({
  customPriceModal,
  closeModal,
  customizedPrices,
  setCustomizedPrices,
  edit,
}: PropsModal & {
  customPriceModal: MenuPriceCustomizationV2Response | boolean | null;
  customizedPrices: MenuPriceCustomizationV2Response[];
  setCustomizedPrices: Dispatch<
    SetStateAction<MenuPriceCustomizationV2Response[]>
  >;
  edit?: boolean;
}) => {
  const [provider, setProvider] = useState<Provider | null>(null);
  const [price, setPrice] = useState(0);

  const data = customPriceModal;

  const handlePriceChange = useCallback((val: number) => {
    setPrice(val);
  }, []);

  useEffect(() => {
    if (edit && typeof data === 'object') {
      setPrice(data?.price || 0);
      setProvider(data?.provider || null);
    }
  }, [data]);

  const emptyForm = () => {
    setPrice(0);
    setProvider(null);
    closeModal?.();
  };

  const handleSubmit = () => {
    if (!provider) return ErrorToast('Please choose provider');
    if (!price) return ErrorToast('Please add Delivery Price');

    const prices = {
      price,
      pickupPrice: price,
      provider,
    };

    if (edit) {
      const updatedPrices = customizedPrices.map((item) => {
        if (item.provider === provider) {
          return prices;
        }
        return item;
      });

      setCustomizedPrices(updatedPrices);
    } else {
      setCustomizedPrices((prev) => [...prev, prices]);
    }
    emptyForm();
  };

  // Filter out providers that are already in customizedPrices
  const filteredProviders = CUSTOM_PRICE_PROVIDERS.filter(
    (providerValue) =>
      !customizedPrices.some((price) => price.provider === providerValue)
  );

  return (
    <>
      <Modal
        isOpen={!!customPriceModal}
        closeModal={closeModal}
        header={
          edit && typeof data === 'object'
            ? `Edit ${renderProviderName(data?.provider || '')} Custom Price`
            : 'Add Custom Price'
        }
        logo={false}
        zIndex={110}
        overflow="visible"
      >
        <Div $flex $column $gap="24px">
          {!edit && (
            <AdminCustomProviderSelect
              value={provider}
              onChange={
                setProvider as (
                  provider: Provider | null | (Provider | null)[]
                ) => void
              }
              providerArray={filteredProviders}
              emptyPlaceholder={'No more providers to add'}
            />
          )}

          <Div $flex $alignCenter $gap="24px">
            <AdminDollarInput2
              label="Price"
              onValueChange={handlePriceChange}
              value={price}
              $textCenter
            />
          </Div>
          <Button $selected $w="100%" onClick={handleSubmit}>
            Confirm
          </Button>
        </Div>
      </Modal>

      <Div $desktop>
        <Tooltip
          clickable
          id={
            "This price is applied for pickup. If you don't fill in the field, the price will be taken from 'Delivery price' field"
          }
          style={{
            maxWidth: '500px',
            background: lightTheme.white,
            color: lightTheme.darkGray,
            padding: 16,
            borderRadius: 20,
            boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.05)',
            zIndex: '1',
          }}
          border="1px solid #e3e3e3"
        />
      </Div>
      <Div $mobile>
        <Tooltip
          id={
            "This price is applied for pickup. If you don't fill in the field, the price will be taken from 'Delivery price' field"
          }
          style={{
            maxWidth: '95%',
            background: lightTheme.white,
            color: lightTheme.darkGray,
            padding: 16,
            borderRadius: 20,
            boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.05)',
            zIndex: '1',
          }}
          border="1px solid #e3e3e3"
        />
      </Div>
    </>
  );
};
